import Icon from './Icon';

type SocialLink = {
  platform: string;
  url: string;
};

type SocialLinkListProps = {
  links: SocialLink[];
  title: string;
  className?: string;
};

const SocialLinkList = ({ links, title, className }: SocialLinkListProps) => {
  return (
    <div className={`md:py-4 p-0${className}`}>
      <h2 className="text-lg font-bold mb-2">{title}</h2>
      <ul className="list-none list-inside flex flex-row items-center gap-5">
        {links.map((link, index) => (
          <li key={index} className="mb-2 py-1">
            <a href={link.url} className="text-theme-link flex items-center gap-2" target="_blank" rel="noopener noreferrer">
              <div>
                <Icon name={link.platform} style="brands" size={32} />
              </div>
              <div className="capitalize">{link.platform}</div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default SocialLinkList;
